import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Container,
  Form,
  FormGroup,
  Col,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";
import Modal from "react-modal";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70vw",
    border: "8px solid #9ba5ad",
    maxHeight: "100vh",
    overflowY: "auto",
  },
};

const ViewAdminForm = (props) => {
  const dispatch = useDispatch();

  const { modal, toggle, userDetails } = props;
  useEffect(() => {
    return () => {
      dispatch({
        type: "SET_ADMIN_USER_DETAILS",
        data: { userDetails: undefined },
      });
    };
  }, [dispatch]);

  if (!userDetails) {
    return null;
  }

  const {
    "custom:uid": uid,
    email,
    given_name,
    family_name,
    "custom:Country": Country,
    "custom:phoneNumber": phoneNumber,
    "custom:mobileNumber": mobileNumber,
    "custom:accessrole": accessrole,
    "custom:userpoolRole": userpoolRole,
    Enabled,
  } = userDetails;

  return (
    <Modal
      isOpen={modal}
      style={customStyles}
      ariaHideApp={false}
      onRequestClose={toggle}
    >
      <Container fluid>
        <Form>
          <h5>Admin Details</h5>
          <hr />
          <Row>
            <Col sm={6}>
              <FormGroup>
                <Label for="uid" id="uid" className="label">
                  User ID:
                </Label>
                <Label for="UIDVal" id="UIDVal">
                  {uid}
                </Label>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="email" id="email" className="label">
                  Email ID:
                </Label>
                <Label for="emailVal" id="emailVal">
                  {email}
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <Label for="firstName" id="firstName" className="label">
                  First Name:
                </Label>
                <Label for="firstNameVal" id="firstNameVal">
                  {given_name}
                </Label>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="lastName" id="lastName" className="label">
                  Last Name:
                </Label>
                <Label for="lastNameVal" id="lastNameVal">
                  {family_name}
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <Label for="phoneNumber" id="phoneNumber" className="label">
                  Company Phone Number:
                </Label>
                <Label for="phoneNumberVal" id="phoneNumberVal">
                  {phoneNumber}
                </Label>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="mobileNumber" id="mobileNumber" className="label">
                  Mobile Number:
                </Label>
                <Label for="mobileNumberVal" id="mobileNumberVal">
                  {mobileNumber}
                </Label>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="country" id="country" className="label">
                  Country:
                </Label>
                <Label for="countryVal" id="countryVal">
                  {Country}
                </Label>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="status" id="status" className="label">
                  Status:
                </Label>
                <Label for="emailVal" id="emailVal">
                  {Enabled ? "Active" : "Inactive"}
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <Label for="userpoolrole" id="userpoolrole" className="label">
                  User Pool Role(s):
                </Label>
                <Input
                  style={{ backgroundColor: "#ffffff" }}
                  type="textarea"
                  id="userpoolroleVal"
                  disabled
                  value={userpoolRole}
                />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <Label for="accessrole" id="accessrole" className="label">
                  Access Role(s):
                </Label>
                <Input
                  style={{ backgroundColor: "#ffffff" }}
                  type="textarea"
                  id="accessroleVal"
                  disabled
                  value={accessrole}
                />
              </FormGroup>
            </Col>
          </Row>
          <Button
            onClick={(e) => {
              e.preventDefault();
              toggle();
            }}
            style={{ float: "right" }}
          >
            Cancel
          </Button>
        </Form>
      </Container>
    </Modal>
  );
};

export default ViewAdminForm;

// import React from 'react';
// import { connect } from 'react-redux';
// import {
// 	Container,
// 	Form,
// 	FormGroup,
// 	Col,
// 	Row,
// 	Label,
// 	Button,
// 	Input,
// } from 'reactstrap';
// import Modal from 'react-modal';
// const customStyles = {
// 	overlay: {
// 		backgroundColor: 'rgba(0,0,0,0.5)',
// 	},
// 	content: {
// 		top: '50%',
// 		left: '50%',
// 		right: 'auto',
// 		bottom: 'auto',
// 		marginRight: '-50%',
// 		transform: 'translate(-50%, -50%)',
// 		width: '70vw',
// 		border: '8px solid #9ba5ad',
// 		maxHeight: '100vh',
// 		overflowY: 'auto',
// 	},
// };

// class ViewUserDetailsAdmin extends React.Component {
// 	componentWillUnmount = () => {
// 		this.props.clearUserDetails();
// 	};

// 	render() {
// 		const { userDetails } = this.props;
// 		const {
// 			'custom:uid': uid,
// 			email,
// 			given_name,
// 			family_name,
// 			'custom:Country': Country,
// 			'custom:phoneNumber': phoneNumber,
// 			'custom:mobileNumber': mobileNumber,
// 			'custom:accessrole': accessrole,
// 			'custom:userpoolRole': userpoolRole,
// 			Enabled,
// 		} = userDetails;
// 		return (
// 			<>
// 				<Modal
// 					isOpen={this.props.modal}
// 					style={customStyles}
// 					ariaHideApp={false}
// 					onRequestClose={this.props.toggle}>
// 					<Container fluid>
// 						<Form>
// 							<h5>Admin Details</h5>
// 							<hr />
// 							<Row>
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label for='uid' id='uid' className='label'>
// 											User ID:
// 										</Label>
// 										<Label for='UIDVal' id='UIDVal'>
// 											{uid}
// 										</Label>
// 									</FormGroup>
// 								</Col>
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label for='email' id='email' className='label'>
// 											Email ID:
// 										</Label>
// 										<Label for='emailVal' id='emailVal'>
// 											{email}
// 										</Label>
// 									</FormGroup>
// 								</Col>
// 							</Row>
// 							<Row>
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label for='firstName' id='firstName' className='label'>
// 											First Name:
// 										</Label>
// 										<Label for='firstNameVal' id='firstNameVal'>
// 											{given_name}
// 										</Label>
// 									</FormGroup>
// 								</Col>
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label for='lastName' id='lastName' className='label'>
// 											Last Name:
// 										</Label>
// 										<Label for='lastNameVal' id='lastNameVal'>
// 											{family_name}
// 										</Label>
// 									</FormGroup>
// 								</Col>
// 							</Row>
// 							<Row>
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label for='phoneNumber' id='phoneNumber' className='label'>
// 											Company Phone Number:
// 										</Label>
// 										<Label for='phoneNumberVal' id='phoneNumberVal'>
// 											{phoneNumber}
// 										</Label>
// 									</FormGroup>
// 								</Col>
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label
// 											for='mobileNumber'
// 											id='mobileNumber'
// 											className='label'>
// 											Mobile Number:
// 										</Label>
// 										<Label for='mobileNumberVal' id='mobilrNumberVal'>
// 											{mobileNumber}
// 										</Label>
// 									</FormGroup>
// 								</Col>
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label for='country' id='country' className='label'>
// 											Country:
// 										</Label>
// 										<Label for='countryVal' id='countryVal'>
// 											{Country}
// 										</Label>
// 									</FormGroup>
// 								</Col>
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label for='status' id='status' className='label'>
// 											Status:
// 										</Label>
// 										<Label for='emailVal' id='emailVal'>
// 											{Enabled ? 'Active' : 'Inactive'}
// 										</Label>
// 									</FormGroup>
// 								</Col>
// 							</Row>
// 							<Row>
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label
// 											for='userpoolrole'
// 											id='userpoolrole'
// 											className='label'>
// 											User Pool Role(s):
// 										</Label>
// 										<Input
// 											style={{ backgroundColor: '#ffffff' }}
// 											type='textarea'
// 											id='userpoolroleVal'
// 											disabled
// 											value={userpoolRole}
// 										/>
// 									</FormGroup>
// 								</Col>{' '}
// 								<Col sm={6}>
// 									<FormGroup>
// 										<Label for='accessrole' id='accessrole' className='label'>
// 											Access Role(s):
// 										</Label>
// 										<Input
// 											style={{ backgroundColor: '#ffffff' }}
// 											type='textarea'
// 											id='accessroleVal'
// 											disabled
// 											value={accessrole}
// 										/>
// 									</FormGroup>
// 								</Col>
// 							</Row>
// 							<Button
// 								onClick={(e) => {
// 									e.preventDefault();
// 									this.props.toggle();
// 								}}
// 								style={{ float: 'right' }}>
// 								Cancel
// 							</Button>
// 						</Form>
// 					</Container>
// 				</Modal>
// 			</>
// 		);
// 	}
// }
// const mapStateToProps = (state) => {
// 	return {};
// };

// const mapDispatchToProps = (dispatch) => {
// 	return {
// 		clearUserDetails: () =>
// 			dispatch({
// 				type: 'SET_ADMIN_USER_DETAILS',
// 				data: { userDetails: undefined },
// 			}),
// 	};
// };
// export default connect(
// 	mapStateToProps,
// 	mapDispatchToProps
// )(ViewUserDetailsAdmin);
